export function getBackupRequiredValidator(field, requiredBackupFields, validators = []) {
  /*
   * If the field is in the requiredBackupFields array, add a required validator to the validators array
   */
  if (requiredBackupFields.includes(field)) {
    validators.push({ validate: "required" });
  }
  return validators;
}
